import { Component, OnInit, ViewChild } from '@angular/core';
import { GeneralService } from '../general.service';
import { MatTableDataSource } from '@angular/material/table';
import { toExcel } from '../modules/export';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatSort } from '@angular/material/sort';
import { SelectionModel } from '@angular/cdk/collections';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { UploadModalComponent } from '../upload-modal/upload-modal.component';

@Component({
  selector: 'app-all-policies',
  templateUrl: './all-policies.component.html',
  styleUrls: [
    './all-policies.component.css',
    '../dasboard/dasboard.component.css',
  ],
})
export class AllPoliciesComponent implements OnInit {
  constructor(
    private s: GeneralService, 
    private fb: FormBuilder,
    private dialog: MatDialog,
    private toaster: ToastrService,
    private r: Router
  ) {
    this.minDate = new Date();
    this.user = JSON.parse(localStorage.getItem('user')!);
  }
  minDate: Date;
  dataSource: any;
  displayedColumns: string[] = [
    'email',
    'netPrice',
    'grossPrice',
    // 'percentage',
    'status',
    'updated_at',
    'policy_detail_id',
  ];
  data: any[] = [];
  sortForm!: FormGroup;
  selection = new SelectionModel<any>(true, []);
  user: { [key: string]: string } = {};
  selectedRows: any[] = [];
  showButtons = false;
  detailsSelect = false;
  openCoverExpiry = false;
  totalGrossPrice = 0
  totalNetPrice = 0
  policyDetailId: Array<string> = [];

  @ViewChild(MatSort)
  sort!: MatSort;

  sanctionedStatus = [
    { value: 'pending', viewValue: 'Pending' },
    { value: 'paid', viewValue: 'Paid' },
  ];

  ngOnInit(): void {
    this.s.getAllTrxns().subscribe((r: any) => {
      this.s.loader = false;
      this.data = r.data.reverse();
      this.dataSource = new MatTableDataSource(this.data);

      
      if (this.user['role'] === 'staff' || this.user['role'] === 'broker') {
        this.checkOpenCoverValidity()
        this.displayedColumns.splice(0, 0, 'select');
      }

      if (this.user['role'] === 'staff' || this.user['role'] === 'broker' && !this.user['unitFn']) {
        this.displayedColumns.splice(0, 0, 'select');
        this.detailsSelect = true;
        this.openCoverExpiry = true;
      }

      this.sortForm = this.fb.group({
        sortStatus: [''],
      });
    });

    if (this.user['role'] === 'staff' || this.user['role'] === 'broker') {
      this.displayedColumns.splice(4, 0, 'reconcile');
    }
  }

  export() {
    new toExcel().export(this.data, 'All-policies');
  }

  isAllSelected() {
    const eligibleRows = this.dataSource.data.filter((row: any) => row.type === 'units' && row.reconciled === 'Not Started');
    return eligibleRows.length > 0 && this.selection.selected.length === eligibleRows.length;
  }

  toggleAllRows() {
    const eligibleRows = this.dataSource.data.filter((row: any) => row.type === 'units' && row.reconciled === 'Not Started');
  
    if (this.isAllSelected()) {
      this.selection.clear();
      this.selectedRows = [];
      this.policyDetailId = [];
    } else {
      this.selection.select(...eligibleRows);
      this.selectedRows = [...eligibleRows];
      this.policyDetailId = eligibleRows.map((row: any) => row.policy_detail_id);
    }
  
    // Reset total before recalculating
    this.totalGrossPrice = 0;
    this.totalNetPrice = 0;
  
    // Recalculate totals
    for (let row of this.selectedRows) {
      if (this.user['role'] === 'staff') {
        this.totalGrossPrice += row['grossPrice'];
      } else if (this.user['role'] === 'broker') {
        this.totalNetPrice += row['netPrice'];
      }
    }
  
    console.log('Selected Rows:', this.selectedRows);
    console.log('Selected Count:', this.selectedRows.length);
    this.AllButton();
  }
  

  AllButton() {
    this.showButtons = this.selection.selected.length >= 1;
  }

  transFilter = this.fb.group({
    startDate: [Date],
    endDate: [Date],
    phone: [
      '',
      [
        Validators.compose([
          Validators.maxLength(11),
          Validators.minLength(11),
          Validators.pattern('^[0-9]*$'),
        ]),
      ],
    ],
    passport: ['', Validators.pattern(/[A-Z]{1}\d{8}$/)],
  });

  cancel = false;
  reset() {
    this.cancel = false;
    this.transFilter.reset();
    this.dataSource.data = this.data;
  }

  sortStatus() {
    let result = this.dataSource.data;
    let result2 = [];

    if (this.sortForm?.value === 'pending') {
      console.log(this.sortForm.value);
      for (let i = 0; i < result.length; i++) {
        let filterStatus = result[i]['status'];
        result2.push(filterStatus);
      }
      this.dataSource.data = result2;
    }
  }

  dateRange() {
    this.cancel = true;
    let result = this.dataSource.data;
    let result2 = [];

    if (
      this.transFilter.get('startDate')?.value != null ||
      '' ||
      (undefined && this.transFilter.get('endDate')?.value != null) ||
      '' ||
      undefined
    ) {
      for (let i = 0; i < result.length; i++) {
        let updatedAtDate = new Date(result[i]['updated_at']);
        let startDate = new Date(
          this.transFilter.get('startDate')!.value!.toString()
        );
        let endDate = new Date(
          this.transFilter.get('endDate')!.value!.toString()
        );

        if (updatedAtDate >= startDate && updatedAtDate <= endDate) {
          result2.push(result[i]);
        }
      }
      this.dataSource.data = result2;
    }
  }

  checkOpenCoverValidity() {
    const today = new Date();
    const payload = {
      emaill: this.user['email'],
      unitFn: false,
    };
    for (let i = 0; i < this.data.length; i++) {
      if (this.data[i]['type'] === 'units') { 
        const createdAt = new Date(this.data[i]['created_at']); 
        const today = new Date(); 
        const diffInDays = Math.floor((today.getTime() - createdAt.getTime()) / (1000 * 60 * 60 * 24)); 
        if(diffInDays == 30 && this.data[i]['reconciled'] !== "Confirmed"){
          this.s.disableOpenCover(payload).subscribe((r) => {
            this.s.loader = false;
            this.openCoverExpiry = true;
          });
        }
      }
    }
    
  }

  logRowData(row: any) {
    if (this.selection.isSelected(row)) {
      if (!this.selectedRows.some((selectedRow) => selectedRow.payId === row.payId)) {
        this.selectedRows.push(row);
        this.policyDetailId.push(row.policy_detail_id);
      }
    } else {
      this.selectedRows = this.selectedRows.filter(
        (selectedRow) => selectedRow.payId !== row.payId
      );
      this.policyDetailId = this.policyDetailId.filter(
        (id) => id !== row.policy_detail_id
      );
    }
  
    // Reset before recalculating
    this.totalGrossPrice = 0;
    this.totalNetPrice = 0;
  
    // Recalculate totals
    for (let i = 0; i < this.selectedRows.length; i++) {
      if (this.user['role'] === 'staff') {
        this.totalGrossPrice += this.selectedRows[i]['grossPrice'];
      } else if (this.user['role'] === 'broker') {
        this.totalNetPrice += this.selectedRows[i]['netPrice'];
      }
    }
  
    console.log('Policy ID:', this.policyDetailId);
    console.log('Selected Rows:', this.selectedRows);
    console.log('Selected Count:', this.selectedRows.length);
    this.AllButton();
  }
  

    upload(enterAnimationDuration: string, exitAnimationDuration: string) {
    let data: Array<string> = this.policyDetailId;
    const dialogRef = this.dialog.open(UploadModalComponent, {
      width: '40vw',
      height: '70vh',
      data,
      enterAnimationDuration,
      exitAnimationDuration,
      // disableClose: true,
    });
    dialogRef.afterClosed().subscribe((r) => {
      // location.reload()
    })
  }
}
